export default __webpack_public_path__ + "static/media/pokedex.d98fe46b.jpg";